export const FETCH_START = 'FETCH_START';
export const FETCH_END = 'FETCH_END';
export const CONTRACT_TYPE_CONFIGURATION_SUCCESS = "CONTRACT_TYPE_CONFIGURATION_SUCCESS";